import React from 'react';
import CardAsset from './CardAsset';

function Assets ({ filteredAssets, origin, assets, stages, filters, configFile }) {
  return (
    <div>
      {
        <div>
          {assets &&
              assets.length > 0 &&
              assets.map(
                (asset, i) =>
                  stages.id === asset.currentStage && (
                    // filtro para solo pintar los assets en los stage que correspondan
                    <div key={i}>
                      <CardAsset configFile={configFile} asset={asset} origin={origin} />
                    </div>
                  )
              )}
        </div>
      }
    </div>
  );
}

export default Assets;
